"use strict";

exports.__esModule = true;
exports.getMembersGroupsByType = exports.hasMembersGroupsByType = exports.getMembersGroupsByIds = exports.getMembersGroups = void 0;

var _lodash = require("lodash");

var getMembersGroups = function getMembersGroups(state) {
  return state.membersGroups;
};

exports.getMembersGroups = getMembersGroups;

var getMembersGroupsByIds = function getMembersGroupsByIds(state, idList) {
  return getMembersGroups(state).filter(function (g) {
    return idList.includes(g.id);
  });
};

exports.getMembersGroupsByIds = getMembersGroupsByIds;

var hasMembersGroupsByType = function hasMembersGroupsByType(state, type) {
  return getMembersGroups(state).findIndex(function (g) {
    return g.type === type;
  }) > -1;
};

exports.hasMembersGroupsByType = hasMembersGroupsByType;

var getMembersGroupsByType = function getMembersGroupsByType(state, type) {
  var list = getMembersGroups(state).filter(function (group) {
    return (0, _lodash.isArray)(type) ? type.includes(group.type) : group.type === type;
  });
  var byId = (0, _lodash.keyBy)(list, 'id');
  return {
    list: list,
    byId: byId,
    count: list.length
  };
};

exports.getMembersGroupsByType = getMembersGroupsByType;